module.exports = __webpack_public_path__ + "static/img/mo_role.55d44e0.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/home/pc/role3/control/mo_role.png
// module id = 3KYf
// module chunks = 7